import { useContext } from "react";
import { Broadcast } from "components/context/StoreProvider";

export default function useBroadCats() {
  return useContext(Broadcast);
}
